import type { ReactNode } from "react";
import { Clock, Settings2 } from "lucide-react";
import { StepInfoRow } from "../StepInfoRow";
import { getString, getNumber } from "./helpers";
import type { SummaryTranslator } from "./types";

export function getDelaySummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const type = getString(config.type) || "duration";

  if (type === "duration" && config.durationMs) {
    const ms = config.durationMs as number;
    const formatted = ms >= 60000 ? `${Math.round(ms / 60000)}m` : `${Math.round(ms / 1000)}s`;
    items.push(
      <StepInfoRow
        key="wait"
        icon={<Clock className="size-3.5" />}
        label={t("summaries.delay.label_wait")}
        value={
          <span className="rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-400">
            {formatted}
          </span>
        }
      />
    );
  } else if (type === "condition") {
    const condition = getString(config.condition);
    if (condition) {
      items.push(
        <StepInfoRow key="waitFor" icon={<Clock className="size-3.5" />} label={t("summaries.delay.label_wait_for")} value={condition} mono />
      );
    }
    const maxWaitMs = getNumber(config.maxWaitMs);
    if (maxWaitMs) {
      items.push(
        <StepInfoRow key="maxWait" icon={<Settings2 className="size-3.5" />} label={t("summaries.delay.label_max_wait")} value={t("summaries.delay.max_wait_seconds", { seconds: Math.round(maxWaitMs / 1000) })} />
      );
    }
  }

  return items;
}
